module.exports = __webpack_public_path__ + "img/wsp_logo.551e4ed1.svg";